// extracted by mini-css-extract-plugin
module.exports = {"grow":"Grow_grow__8w_Yf","inner":"Grow_inner__UI9XX"};